<!--
 * @Description: 系统头部组件
 * @Date: 2019-09-26 14:50:56
 * @LastEditTime: 2019-10-17 15:34:00
 -->
<template>
    <header class="home-header">
        <div class="home-header-inner">
            <img class="ebbly-logo" src="../../../assets/images/logo.png" @click="jump" />

            <ul class="header-menu">
                <li class="menu-item">
                    <el-select
                        v-model="currency"
                        @change="changeCurrency"
                        value-key="abbreviation"
                        :disabled="payDisable"
                    >
                        <el-option
                            v-for="item in list"
                            :key="item.abbreviation"
                            :label="item.abbreviation"
                            :value="item"
                        >
                            <span style="float: left">
                                <img class="currency-flag" v-lazy="item.image_url" />
                                {{ item.abbreviation }}
                            </span>
                            <span
                                class="currency-zone"
                                :title="item.country_name"
                            >{{ item.country_name }}</span>
                        </el-option>
                    </el-select>
                </li>
                <li class="menu-item lang-select">
                    <el-select v-model="lang" @change="selectLang">
                        <el-option
                            v-for="(item, index) in langList"
                            :key="index"
                            :label="item.text"
                            :value="item.lang"
                        ></el-option>
                    </el-select>
                </li>
                <li class="menu-item">
                    <a
                        href="https://www.ebbly.com/download.html#/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >{{$t('download_app')}}</a>
                </li>
                <li
                    class="menu-item user-imp"
                    v-if="!token"
                    @click="signin"
                >{{$t('signin')}} / {{$t('signup')}}</li>
                <li class="menu-item user-imp" v-else>
                    <el-dropdown @command="selectUserMenu">
                        <span class="user-dropdown">
                            <span
                                class="user-avatar"
                                v-lazy:background-image="{
                                src: avatar || require('../../../assets/avatar/default_avartar_boy@2x.png'),
                                error: require('../../../assets/avatar/default_avartar_boy@2x.png')
                            }"
                            ></span>
                            <span class="line-text">{{name}}</span>
                        </span>

                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item
                                v-for="(item, index) in userMenu"
                                :key="index"
                                :command="item.link"
                            >{{$t(item.text)}}</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </li>
            </ul>
        </div>
    </header>
</template>

<script>
import { mapGetters } from "vuex";
//语言列表
const LANG_LIST = [
    {
        lang: "zh-CN",
        text: "简体中文"
    },
    {
        lang: "zh-HK",
        text: "繁体中文"
    },
    {
        lang: "en-US",
        text: "English"
    }
];

export default {
    data() {
        return {
            //当前货币列表
            list: [],
            currency: "USD", //默认单位为美金
            langList: LANG_LIST,
            lang: "en-US",
            payDisable: false, //禁用货币选择
            userMenu: [
                {
                    text: "edit_profile",
                    link: "/user/profile"
                },
                {
                    text: "my_order",
                    link: "/user/order/hotel"
                },
                {
                    text: "coupon",
                    link: "/user/coupon"
                },
                {
                    text: "collection",
                    link: "/user/fav"
                },
                {
                    text: "help_center",
                    link: "/allhelp"
                },
                {
                    text: "exit",
                    link: ""
                }
            ]
        };
    },
    computed: {
        ...mapGetters(["token", "user", "unit", "avatar"]),
        name() {
            if (!this.token) {
                return "";
            }
            return (
                (this.user.user_info.first_name || "") +
                (this.user.user_info.last_name || "")
            );
        }
    },
    watch: {
        //货币变化
        unit: {
            immediate: true,
            handler: function(val) {
                this.currency = val;
            }
        },

        //监听路由变化
        $route: {
            immediate: true,
            handler: function(to) {
                if (!to) {
                    return;
                }
                if (
                    to.name.toLowerCase() === "payment" ||
                    to.name.toLowerCase() === "checkout" ||
                    to.name.toLowerCase() === "orderform" ||
                    to.name.toLowerCase() === "airpayment" ||
                    to.name.toLowerCase() === "hotelform"
                ) {
                    this.payDisable = true;
                } else {
                    this.payDisable = false;
                }
            }
        }
    },
    created() {
        this.getCurrency();
        this.lang = this.$local.get("lang") || "en-US";
    },
    methods: {
        /**
         * 请求货币列表及相应的汇率
         */
        getCurrency() {
            this.$req.post("v2/rate").then(({ data }) => {
                if (data.code === "2000") {
                    this.list = data.data.hot_rate;
                }
            });
        },

        /**
         * 改变货币触发
         */
        changeCurrency({ abbreviation, ups }) {
            //切换用户当前所在地区
            this.$store.dispatch("updateCountry", ups);

            //更新汇率
            this.$store.dispatch("updateUnit", abbreviation);
        },

        /**
         * 切换语言
         * @param {String} val 目标语言
         */
        selectLang(val) {
            this.$local.set("lang", val);
            this.$local.remove("recomandCitys");
            this.$store.dispatch("updateCountryList", true).then(() => {
                location.reload();
            });
        },

        /**
         * 用户操作选项
         * @param {String} link 跳转链接，有则跳转，无则为退出操作
         */
        selectUserMenu(link) {
            if (!link) {
                //退出
                //退出登录
                this.logout();
                return;
            }

            if (this.$route) {
                /* 存在路由，则用路由跳转 */
                this.$router.push(link);
                return;
            }

            window.open(process.env.VUE_APP_PC + link, "_blank");
        },

        jump() {
            if (this.$route) {
                location.replace(location.origin);
            }
        },

        /**
         * 登录
         */
        signin() {
            this.$store.dispatch("toggleShowLogin", true);
        },

        /**
         * 退出登录
         */
        logout() {
            //回到首页
            this.jump();

            //退出登录时，尝试取回定位时的country code码
            let cacheCountry = this.$local.get("gis.area"); //定位的国家/地区数据
            this.$store.dispatch("updateCountry", cacheCountry);

            this.$store.dispatch("updateToken", null);
            try {
                FB.getLoginStatus(function(response) {
                    if (response.status === "connected") {
                        //在登录状态则退出facebook登录
                        FB.api(
                            "me/permissions?success:true",
                            "delete",
                            function(res) {
                                console.info("logout");
                            }
                        );
                    }
                });
            } catch (error) {
                console.warn(error);
            }
        }
    }
};
</script>

<style>
.el-select-dropdown__item {
    min-width: 200px;
}
.el-select-dropdown__item > .currency-zone {
    float: right;
    color: #8492a6;
    font-size: 14px;
    max-width: 50%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

.el-select-dropdown__item .currency-flag {
    width: 18px;
    vertical-align: text-top;
    margin-right: 5px;
}

.home-header-inner .el-input__inner {
    background-color: transparent;
    color: #fff;
    border-radius: 12px;
    width: 90px;
    height: 24px !important;
    font-size: 12px;
}

.home-header-inner .lang-select .el-input__inner {
    width: 110px;
}

.home-header-inner .el-input__icon {
    line-height: 24px;
}

.home-header-inner .el-select .el-input.is-focus .el-input__inner,
.home-header-inner .el-select .el-input__inner:focus {
    border-color: #fff;
}
</style>

<style lang="scss" scoped>
.home-header {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    height: 80px;
    width: 100%;
    background: linear-gradient(
        360deg,
        rgba(0, 0, 0, 0.0182858) -8.43%,
        rgba(0, 0, 0, 0.328068) 100%
    );

    .home-header-inner {
        width: 1140px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .user-dropdown {
            display: flex;
            align-items: center;
            font-size: 18px;
            color: #fff;
        }

        .line-text {
            max-width: 100px;
            line-height: 22px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
        }

        .ebbly-logo {
            height: 100%;
            cursor: pointer;
        }

        .header-menu {
            display: flex;
            align-items: center;
            list-style: none;
            color: #fff;
            font-size: 18px;

            .menu-item {
                padding-left: 25px;
                transition: opacity ease-in-out 0.3s;

                &:hover {
                    opacity: 0.8;
                }
            }

            .user-imp {
                display: flex;
                align-items: center;
                cursor: pointer;

                .user-avatar {
                    display: inline-block;
                    height: 24px;
                    width: 24px;
                    margin-right: 15px;
                    background-position: center;
                    background-size: cover;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/home/components/Header.vue